import { render, staticRenderFns } from "./SearchEmptyView.vue?vue&type=template&id=4e4bf1e2&scoped=true"
import script from "./SearchEmptyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchEmptyView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchEmptyView.vue?vue&type=style&index=0&id=4e4bf1e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4bf1e2",
  null
  
)

export default component.exports